/**
 * User info bar component
 * Displays logged-in user's information and provides logout functionality
 */

import React from 'react';
import { AuthState } from '../types';

interface UserInfoBarProps {
  authState: AuthState;
  onLogout: () => void;
}

const UserInfoBar: React.FC<UserInfoBarProps> = ({ authState, onLogout }) => {
  const { userProfile } = authState;

  if (!userProfile) {
    return null;
  }

  const handleLogoutClick = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
    }
  };

  return (
    <div className="user-info-bar">
      <div className="user-info">
        <span>
          Logged in as: <strong>{userProfile.printableName}</strong>
        </span>
        <span>
          Manager ID: <strong>{authState.managerId || 'N/A'}</strong>
        </span>
        <span>
          Email: <strong>{userProfile.email}</strong>
        </span>
      </div>
      
      <div className="user-actions">
        <button
          onClick={handleLogoutClick}
          className="logout-button"
          title="Logout"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default UserInfoBar; 